import { render, staticRenderFns } from "./ProductOrders.vue?vue&type=template&id=cdea2efa"
import script from "./ProductOrders.vue?vue&type=script&lang=js"
export * from "./ProductOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports